import { EstateCount } from "common/interfaces/EstateCount";
import { getJsonMaster } from "./common";

export const getEstateCounts = (
  prefCode: string,
  cityCode: string,
  status: string
) =>
  getJsonMaster<EstateCount>(`estate_counts/${prefCode}/${cityCode}/${status}`);
